<template>
  <div class="list">
    <div class="search" v-if="search">
      <input type="text" :placeholder="app.strings.common.search" v-model="query" />
      <font-awesome-icon class="icon" :icon="['fas', 'search']" />
    </div>
    <div class="list">
      <div class="row" v-for="item in itemsFiltered" v-bind:key="item[index]" v-on:click="$emit('onSelect', item)">
        <div>{{ item[value] }}</div>
        <font-awesome-icon class="icon chevron" :icon="['fas', 'chevron-right']" />
      </div>
      <slot name="rows"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'list',
  data () {
    return {
      query: ''
    }
  },
  computed: {
    itemsFiltered () {
      let items = this.items

      if (this.query.trim().length > 0) {
        items = items.filter((item) => {
          return item.toLowerCase().indexOf(this.query.toLowerCase()) != -1
        })
      }

      this.$emit('onSearch', items)

      return items
    }
  },
  props: {
    'app': {
      type: Object,
      default: () => {
        return {}
      }
    },
    'items': {
      type: Array,
      default: () => {
        return []
      }
    },
    'index': {
      type: String,
      default: () => {
        return 'id'
      }
    },
    'value': {
      type: String,
      default: () => {
        return 'name'
      }
    },
    'search': {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  mounted () {

  },
  methods: {

  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// Valkiria look: this component is only used in the app screens.

.search {
  position: relative;
  margin-bottom: 4px;
}

.search > input {
  width: 100%;
  height: 48px;
  background-color: #FFFFFF;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  color: #1f2a37;
  font-size: 16px;
  box-sizing: border-box;
}

.search > input::placeholder {
  color: #64748b;
  font-size: 16px;
}

.search > .icon {
  position: absolute;
  top: 16px;
  left: 16px;
  color: #64748b;
}

.row {
  display: flex;
  width: 100%;
  min-height: 60px;
  align-items: center;
  padding: 10px 14px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  border: 1px solid #e8edf3;
  margin: 10px 0;
  border-radius: 16px;
  box-shadow: 0 12px 30px rgba(20, 67, 107, 0.08);
  cursor: pointer;
}

.row > img {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  border: 2px solid rgba(32, 113, 183, 0.25);
}

.row > div {
  flex: 1;
  padding: 0 0 0 12px;
  color: #1f2a37;
  font-family: 'Lexend', sans-serif;
  font-size: 15px;
  font-weight: 500;
}

.row > div.right {
  text-align: right;
}

.row > div > span.badge {
  padding: 4px 10px;
  border-radius: 999px;
  background-color: rgba(32, 113, 183, 0.1);
  color: #2071b7;
  font-family: 'Lexend', sans-serif;
  font-size: 12px;
  font-weight: 700;
}

.row > .icon.chevron {
  color: #64748b;
}

.row.danger {
  border-color: rgba(220, 53, 69, 0.35);
}

.row.danger > div {
  color: #dc3545;
}

.row.danger > div > span.badge {
  background-color: rgba(220, 53, 69, 0.12);
  color: #dc3545;
}
</style>
